module.exports = __webpack_public_path__ + "img/whiteTripAdvisor.f14b11d3.png";